// Keep the hash and use an absolute URL so a // pathname stays on its origin.
export const getAuthReturnUrl = (originalUrl: string, origin: string) => {
  const url = new URL(originalUrl);
  return url.origin === origin ? url.toString() : originalUrl;
};
